// @ts-check
import { createContext, useContext } from "react";

/**
 * @type {React.Context<{
 *   messages: any[],
 *   previousMessages: any[],
 *   complete: boolean,
 *   hasError: boolean,
 *   setUserHasScrolledUp: () => void,
 *   userHasScrolledUp: boolean,
 *   question: string,
 *   setQuestion: (nextQuestion: string) => void,
 *   onSessionClear: () => void,
 *   onSendQuestion: () => void,
 *   showLoader: boolean,
 *   onStartNewChat: () => void,
 *   onSubmitMessageFeedback: (feedback: { messageId: string, feedbackRating: string, feedbackComment?: string }) => Promise<any>,
 * }>}
 */
export const AIChatContext = createContext({
  messages: [],
  previousMessages: [],
  complete: false,
  hasError: false,
  setUserHasScrolledUp: () => {},
  userHasScrolledUp: false,
  question: "",
  setQuestion: () => {},
  onSessionClear: () => {},
  onSendQuestion: () => {},
  showLoader: false,
  onStartNewChat: () => {},
  onSubmitMessageFeedback: () => {},
});

export const useAIChat = () => {
  return useContext(AIChatContext);
};
